import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Mask } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const SVIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="SV" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#F7FCFF"
        fillRule="evenodd"
        d="M0 0v12h16V0H0Z"
        clipRule="evenodd"
      />
      <Mask
        id="b"
        width={16}
        height={12}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "luminance",
        }}
      >
        <Path
          fill="#fff"
          fillRule="evenodd"
          d="M0 0v12h16V0H0Z"
          clipRule="evenodd"
        />
      </Mask>
      <G mask="url(#b)">
        <Path
          fill="#3D58DB"
          fillRule="evenodd"
          d="M0 0v4h16V0H0ZM0 8v4h16V8H0Z"
          clipRule="evenodd"
        />
        <Path
          stroke="#E8AA00"
          strokeWidth={0.5}
          d="M7.892 4.108a1.821 1.821 0 1 1-.001 3.643 1.821 1.821 0 0 1 .001-3.643Z"
        />
        <Path
          fill="#1E601B"
          fillRule="evenodd"
          d="M6.905 4.831s-.476.784-.476 1.322.57 1.214 1.467 1.214c.875 0 1.504-.522 1.523-1.214.019-.692-.47-1.184-.47-1.184s.276.996.138 1.4c-.139.403-.587.891-1.191.83-.604-.063-1.176-.806-1.176-1.046s.185-1.322.185-1.322Z"
          clipRule="evenodd"
        />
        <Path stroke="#188396" strokeWidth={0.5} d="M7.08 6.164h1.604" />
        <Path
          stroke="#E8AA00"
          strokeWidth={0.5}
          d="M7.23 5.903h1.38M8.525 6.206H7.296l.62-1.029.609 1.029Z"
        />
      </G>
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
